import { Route } from 'react-router-dom';
import { Help } from './help/Help';
import { EntityView } from '@/common/entityFramework/entityView/EntityView';

const adminRoutes = [
  <Route path="/admin/help" element={<Help />} />,
  <Route path="/admin/user" element={<EntityView />} />,
  <Route path="/admin/group" element={<EntityView />} />,
  <Route path="/admin/role" element={<EntityView />} />,

]

export default adminRoutes;
